import { render } from "./AuthKitHero.vue?vue&type=template&id=683c3ece&scoped=true"
import script from "./AuthKitHero.vue?vue&type=script&lang=js"
export * from "./AuthKitHero.vue?vue&type=script&lang=js"

import "./AuthKitHero.vue?vue&type=style&index=0&id=683c3ece&lang=css"
import "./AuthKitHero.vue?vue&type=style&index=1&id=683c3ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683c3ece"]])

export default __exports__